import React from 'react';
import email from '../../components/email.json';
import loadingspin from '../../images/loading_spinner.gif';

export default function ProgressMessage() {
  return (
    <main>
      <div className="optinSplash" id="optinSplash">
        <span>
          <label className="lblProcessing" id="lblProcessing" aria-label="Processing">{email.optin.splash.label.processing.eng}</label>
        </span>
        <table border="0" cellPadding="0" cellSpacing="0">
          <tbody>
            <tr>
              <td align="left">
                <label className="lblPleaseWait" id="lblPleaseWait" aria-label="PleaseWait">{email.optin.splash.label.pleaseWait.eng}</label>
              </td>
            </tr>
            <tr>
              <td height="8">&nbsp;</td>
            </tr>
            <tr>
              <td align="center"><img src={loadingspin} alt="Processing" width="19" height="19" /></td>
            </tr>
            <tr>
              <td height="40">&nbsp;</td>
            </tr>
          </tbody>
        </table>
      </div>
    </main>
  );
}
